import { Component, OnInit, ChangeDetectionStrategy, Input, AfterViewInit, Inject } from '@angular/core';
import { ComponentPortal, ComponentType, CdkPortalOutletAttachedRef } from '@angular/cdk/portal';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.scss']
})
export class WindowComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  component: ComponentType<any>;

  @Input()
  help: string;

  componentPortal: ComponentPortal<any>;
  windowContentInstance: any;

  shakeIt: boolean;

  ngOnInit(): void {
    this.componentPortal = new ComponentPortal(this.component);
  }

  attached(windowContentRef: any) {
    this.windowContentInstance = windowContentRef.instance;
  }

  letsShakeIt() {
    this.shakeIt = true;
    setTimeout(() => {
      this.shakeIt = false;
    },
      300);
  }

}
